export default {
	SET_SECTIONS: 'SET_SECTIONS',
	SELECT_SECTION: 'SELECT_SECTION',
	SET_CURRENT_SECTION: 'SET_CURRENT_SECTION'
};